module.exports = __webpack_public_path__ + "static/media/delete.9d90fee1.svg";